/**
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import APIClient from '../../common/APIClient';
import { withApplicationContext, withCustomerSiteContext } from '../../common/HOCs';

export const UserContext = React.createContext();
export const UserConsumer = UserContext.Consumer;

class UserProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: null,
      selectedRows: [],
      isConfirmDeleteModalOpen: false,
      selectedUser: '',
    };
  }

  render() {
    return (
      <UserContext.Provider
        value={{
          // state vars
          users: this.state.users,
          selectedRows: this.state.selectedRows,
          isConfirmDeleteModalOpen: this.state.isConfirmDeleteModalOpen,
          isConfirmSingleDeleteModalOpen: this.state.isConfirmSingleDeleteModalOpen,
          selectedUser: this.state.selectedUser,

          // api methods
          createUser: this.createUser,
          editUser: this.editUser,
          fetchUsers: this.fetchUsers,
          deleteUsers: this.deleteUsers,
          deleteUser: this.deleteUser,
          toggleConfirmDeleteUserModal: this.toggleConfirmDeleteUserModal,
          toggleConfirmSingleDeleteUserModal: this.toggleConfirmSingleDeleteUserModal,
          setSelectedRows: this.setSelectedRows,
          clearSelectedUsers: this.clearSelectedUsers,
          setSelectedUser: this.setSelectedUser,
        }}
      >
        {this.props.children}
      </UserContext.Provider>
    );
  }

  createUser = async (createUserForm) => {
    try {
      const response = await APIClient.createUser(
        createUserForm,
        this.props.appContext.user,
        this.props.custSiteContext.selectedCustomer
      );
      this.props.appContext.setNotification(`User ${createUserForm.email} was created.`, 'success');
    } catch (err) {
      return this.props.appContext.handleModalError(err);
    }
  };

  fetchUsers = async () => {
    let users = [];
    try {
      // EVS2-822 : If the value of siteid is null then make it -1, which s the default site.
      let selectedSiteId = -1;
      if (
        this.props.custSiteContext.selectedSite != undefined &&
        this.props.custSiteContext.selectedSite != null &&
        this.props.custSiteContext.selectedSite != ''
      )
        selectedSiteId = this.props.custSiteContext.selectedSite;

      // get the selected customer
      users = await APIClient.fetchUsers(
        this.props.appContext.user,
        this.props.custSiteContext.selectedCustomer,
        selectedSiteId
      );
      users = users.response;
      this.setState({ users });
      return users;
    } catch (err) {
      this.setState({ users });
      this.props.appContext.handleError(err);
      return users;
    }
  };

  editUser = async (editUserForm) => {
    try {
      const response = await APIClient.editUser(
        editUserForm,
        this.props.appContext.user,
        this.props.custSiteContext.selectedCustomer
      );
      this.props.appContext.setNotification(`User ${editUserForm.email} was modified.`, 'success');
      this.setSelectedRows([]);
    } catch (err) {
      return this.props.appContext.handleModalError(err);
    }
  };

  deleteUsers = async () => {
    try {
      let message = '';
      let userNames = '';
      let operCount = 0;
      const userArray = this.state.selectedRows;
      if (userArray.length > 1) {
        userArray.forEach(function (user) {
          if (operCount > 0) {
            userNames = `${userNames},${user.email}`;
          } else {
            userNames = user.email;
          }
          operCount++;
        });
        message = 'Users deleted successfully.';
      } else {
        userNames = userArray[0].email;
        message = 'User deleted successfully.';
      }
      const response = await APIClient.deleteUsers(
        userNames,
        this.props.appContext.user,
        this.props.custSiteContext.selectedCustomer
      );
      this.setState({
        isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen,
        selectedRows: [],
      });
      this.props.appContext.setNotification(message, 'success');
    } catch (err) {
      this.setState({
        isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen,
        selectedRows: [],
      });
      return this.props.appContext.handleError(err);
    }
  };

  deleteUser = async () => {
    try {
      const message = 'User deleted successfully.';

      const response = await APIClient.deleteUsers(
        this.state.selectedUser.userName,
        this.props.appContext.user,
        this.props.custSiteContext.selectedCustomer
      );
      this.setState({
        isConfirmSingleDeleteModalOpen: !this.state.isConfirmSingleDeleteModalOpen,
        selectedRows: [],
      });
      this.props.appContext.setNotification(message, 'success');
    } catch (err) {
      this.setState({
        isConfirmSingleDeleteModalOpen: !this.state.isConfirmSingleDeleteModalOpen,
        selectedRows: [],
      });
      return this.props.appContext.handleError(err);
    }
  };

  toggleConfirmDeleteUserModal = () => {
    this.setState({ isConfirmDeleteModalOpen: !this.state.isConfirmDeleteModalOpen });
  };

  toggleConfirmSingleDeleteUserModal = () => {
    this.setState({ isConfirmSingleDeleteModalOpen: !this.state.isConfirmSingleDeleteModalOpen });
  };

  clearSelectedUsers = () => {
    this.setState({ selectedRows: [] });
  };

  setSelectedRows = (selectedRows) => {
    this.setState({ selectedRows });
  };

  setSelectedUser = (user) => {
    this.setState({ selectedUser: user });
  };
}

export default withApplicationContext(withCustomerSiteContext(UserProvider));
